import { ref, watch } from 'vue'

// 深色科技风为唯一主题（对齐 city-monitor-web，无浅色模式）
const isDark = ref(true)

function applyTheme() {
  document.documentElement.setAttribute('data-theme', 'dark')
}

watch(isDark, applyTheme, { immediate: true })

export function useTheme() {
  function toggle() {
    /* 单主题系统：保留接口避免调用方报错，不切换 */
  }
  return { isDark, toggle }
}

export function initTheme() {
  applyTheme()
}
